<template>
  <div>
    <div class="content-infos-sigles">
      <div
        v-for="(sigle, index) in sigles"
        :key="index"
        @click="hover = sigle"
        :class="{ active: hover == sigle }"
      >
        <img
          :src="require('@/assets/tweet/sigles/' + sigle.icon)"
          alt=""
          width="90"
        />
      </div>
    </div>
    <div class="content-infos-significations" v-if="hover.name">
      <h3>
        <img
          :src="require('@/assets/tweet/sigles/' + hover.icon)"
          alt=""
          width="90"
        />
        ({{ hover.name }})
      </h3>
      <p v-html="hover.infos"></p>
    </div>
  </div>
</template>

<script>
import sigles from "./config/sigles.json";

export default {
  name: "Sigle",
  data: () => ({
    hover: {},
    sigles: sigles.sigles,
  }),
  watch: {
    //game tweet, exemple: get all arobase class for put active class on
    hover: function (val) {
      let elements = document.querySelectorAll(".active");
      let elements2 = document.querySelectorAll(".active-content-share");

      if (elements) {
        for (let element of elements) {
          element.classList.remove("active");
        }
      }

      if (elements2) {
        for (let element2 of elements2) {
          element2.classList.remove("active-content-share");
        }
      }

      if (val.name) {
        let elements = document.querySelectorAll("." + this.hover.class);
        if (elements) {
          for (let element of elements) {
            if (this.hover.class == "content-share") {
              element.classList.add("active-content-share");
            } else {
              element.classList.add("active");
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
.content {
  &-infos {
    &-sigles {
      display: flex;
      flex-wrap: wrap;
      margin-top: 3rem;
      justify-content: flex-start;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90px;
        height: 90px;
        border: 2px solid black;
        margin: 0 0.5rem 0.5rem 0;
        cursor: pointer;

        &:hover {
          background-color: #86e2ce;
        }
      }

      @media (max-width: 1200px) {
        margin-bottom: 2rem;
      }
    }
    &-significations {
      h3 {
        margin: 0;
        display: flex;
        align-items: center;
        img {
          margin-right: 1rem;
        }
      }
      padding: 2rem;
      margin-top: 1rem;
      background-color: #86e2ce;
    }
  }
}
</style>

